<template>
  <a-form-item
    v-if="nodeId"
    label="Selecciona el nodo a volver"
    name="node_to_back"
    :rules="[{ required: true, message: 'Por favor ingresar el nodo a volver' }]"
  >
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :value="value"
      placeholder="Lista de nodos"
      @update:value="handleChange"
      @change="emit('change')"
    >
      <a-select-option v-for="item in parentNodeList" :key="item" :value="item.id">
        MN{{ item.id }}
      </a-select-option>
    </a-select>
  </a-form-item>
  <p class="info">Se volverá a reproducir el audio del nodo seleccionado.</p>
</template>

<script setup lang="ts">
import { ref, onMounted, toRefs } from "vue";
import { nodeServices } from "@/app/ivr/bot/services/NodeServices";

export interface Props {
  nodeId: number;
  value: number;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  required: false,
});

const { nodeId } = toRefs(props);

export interface Parents {
  id: number;
  order: number;
  ivr: number;
}

const parentNodeList = ref<Parents[]>([]);

const emit = defineEmits(["update:value", "change"]);

const handleChange = (newValue: number) => emit("update:value", newValue);

const getParentNodes = async () => {
  try {
    parentNodeList.value = await nodeServices.getParentNodes(nodeId.value);
  } catch (error) {
    console.error("Error fetching parent nodes:", error);
  }
};

onMounted(async () => {
  await getParentNodes();
});
</script>

<style lang="sass">
.info
  color: $gray-7
  margin-bottom: 0
</style>
